<template>
  <iframe-render :contentId="contentId" :dealId="dealId" :dataId="dataId"></iframe-render>
</template>
<script>
  import iframeRender from './iframeRender'
  export default {
    data() {
      return {
        contentId: 0,
        dealId: 0,
        dataId: 0
      }
    },
    created() {
      this.dealId = parseInt(this.$route.params.id)
      this.contentId = parseInt(this.$route.params.contentId)
      this.dataId = this.$route.query.dataId ? parseInt(this.$route.query.dataId) : 0
    },
    methods: {
    },
    components: {
      iframeRender
    }
  }
</script>


// WEBPACK FOOTER //
// iframe.vue?5b846fff